import { Popover } from "antd-mobile"
import styled from "styled-components"

export const OnboardingHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: var(--header-height);
  padding: 0 var(--app-horizontal-padding);
`

export const HeaderBackBox = styled.div`
  display: flex;
  position: absolute;
  left: 19px;
`

export const HeaderBackButton = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  justify-content: center;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
`

export const HeaderInfoBox = styled.div`
  display: flex;
  position: absolute;
  right: 16px;
`

export const HeaderInfoButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  cursor: pointer;
`

export const MeshDisclaimerPopover = styled(Popover)`
  --arrow-size: 0px;

  .adm-popover-inner {
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(16px);
    padding: 12px 16px;
    width: min(
      calc(100vw - 2 * var(--app-horizontal-padding)),
      calc(var(--app-max-width) - 2 * var(--app-horizontal-padding))
    );
    position: relative;
    left: -10px;
    top: -16px;
  }

  .adm-popover-inner-content {
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6;
    padding: 0;
  }
`
